// Pure helpers for the host lobby. The Stimulus controller polls and paints.

export function waitingIds(people) {
  return people.map((person) => String(person.id))
}

export function lobbySignature(people) {
  return people.map((person) => `${person.id}\n${person.name}`).join("\n")
}

// Ids that were not in the previous poll. The host drawer opens for these.
export function newcomers(previousIds, people) {
  const known = new Set(previousIds.map(String))
  return waitingIds(people).filter((id) => !known.has(id))
}

export function lobbyMarkup(people, { admitUrl, admitLabel, emptyLabel, csrf }) {
  if (!people.length) {
    return `<p class="call-drawer__hint">${escapeHtml(emptyLabel)}</p>`
  }

  const items = people.map((person) => `
    <li>
      <span>${escapeHtml(person.name)}</span>
      <form class="button_to" method="post" action="${escapeHtml(admitUrl)}">
        <input type="hidden" name="authenticity_token" value="${escapeHtml(csrf)}" autocomplete="off">
        <input type="hidden" name="admission_id" value="${escapeHtml(person.id)}">
        <button class="call-dock__button call-dock__button--join" type="submit">${escapeHtml(admitLabel)}</button>
      </form>
    </li>
  `).join("")
  return `<ul class="call-room__waiting">${items}</ul>`
}

function escapeHtml(value) {
  return String(value ?? "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#39;")
}
